/**
 * Default write options for the app's `NuqsAdapter`. `shallow: false` keeps
 * React Router's location in sync with nuqs writes, so code that rebuilds a URL
 * from `useLocation().search` does not drop the params nuqs owns.
 *
 * Why it must stay false: `docs/internal/architecture/frontend.md`, "URL state
 * management".
 */
export const NUQS_ADAPTER_DEFAULT_OPTIONS = { shallow: false } as const;
